import { Avatar, AvatarFallback, AvatarImage } from '@repo/ui'
import { CircleUserRoundIcon } from 'lucide-react'
import React from 'react'

import { cn } from '../lib'

interface IProps {
  avatarUrl?: string
  className?: string
  userData?: { last_name?: string; name?: string }
}

export const KitAvatar = ({ avatarUrl, className, userData }: IProps) => {
  return (
    <Avatar className={cn('size-10', 'mr-2', className)}>
      <AvatarImage src={avatarUrl} />
      <AvatarFallback>
        {userData?.name ? (
          <div className={'rounded-full p-2 font-semibold uppercase'}>
            {userData.name.charAt(0)}
            {userData.last_name && userData.last_name.charAt(0)}
          </div>
        ) : (
          <CircleUserRoundIcon className={cn('size-10', className)} />
        )}
      </AvatarFallback>
    </Avatar>
  )
}
